import { Component } from '@angular/core';
import { ResubscribeClientModalComponent } from '@components/base/client/modals/resubscribe-client-modal/resubscribe-client-modal';

@Component({
	selector: 'resubscribe-client-modal',
	template: require('./resubscribe-client-modal.html'),
	styles: [require('./resubscribe-client-modal.scss')]
})
export class ResubscribeClientModalWebComponent extends ResubscribeClientModalComponent {
	switchModal(isSuccess) {
		const self = this;

		$('#resubscribeClientModal.in')
			.modal('hide')
			.on('hidden.bs.modal', function() {
				const notResubscribeModals = $(
					'.modal.in:not(#resubscribeClientModal)'
				);

				if ($('.in.modal').length > 0) {
					document.body.classList.add('modal-open');
					notResubscribeModals.children('.modal-dialog').css({ overflow: '' });
				}

				isSuccess
					? self.successResubscribeClient.emit()
					: self.cancelResubscribeClient.emit();

				$(this).off('hidden.bs.modal');

				notResubscribeModals.children('.modal-dialog').css({ overflow: '' });
			});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal.ts